import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useEffect } from "react";
import { useSidebar } from "../context/SidebarContext";
import { AddToCardIcon } from "../icons";

export default function AppCardbar() {
    // ✅ from SidebarContext (updated version that includes cartbar)
    const { isCartbarOpen, closeCartbar } = useSidebar();

    // prevent background scrolling when cart is open
    useEffect(() => {
        document.body.style.overflow = isCartbarOpen ? "hidden" : "auto";
    }, [isCartbarOpen]);

    return (
        <>
            {/* Overlay */}
            {isCartbarOpen && (
                <div
                    className="fixed inset-0 bg-black/40 z-40"
                    onClick={closeCartbar}
                ></div>
            )}

            {/* Cartbar Drawer */}
            <div
                className={`fixed top-0 right-0 h-full w-80 sm:w-96 bg-white dark:bg-gray-900 shadow-lg transform transition-transform duration-300 z-50 ${isCartbarOpen ? "translate-x-0" : "translate-x-full"
                    }`}
            >
                {/* Header */}
                <div className="flex items-center justify-between border-b border-gray-200 dark:border-gray-700 p-4">
                    <h2 className="text-lg font-semibold text-gray-800 dark:text-gray-100">
                        Your Cart
                    </h2>
                    <button
                        onClick={closeCartbar}
                        className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full"
                    >
                        <X className="w-5 h-5 text-gray-600 dark:text-gray-300" />
                    </button>
                </div>

                {/* Empty Cart State */}
                <div className="flex flex-col items-center justify-center h-[calc(100%-4rem)] text-center px-4">
                    <AddToCardIcon className="w-16 h-16 text-gray-400 mb-4" />
                    <p className="text-gray-600 dark:text-gray-400 mb-4">
                        No products in the cart.
                    </p>
                    <p
                        onClick={closeCartbar}
                        className="brand-bg brand-bg-hover text-white px-5 py-2 rounded-md font-medium transition"
                    >
                        Return To Shop
                    </p>
                </div>
            </div>
        </>
    );
}
